import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../_services/admin.service';
import { Observable } from 'rxjs';
import { GlobalDataService } from '../../_shared';
import { ConfirmationDialogService } from '../../_services/confirmation-dialog.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';
import {
  map,
  debounceTime,
  distinctUntilChanged
} from "rxjs/operators";
import { MstContracts } from '../../_models/mst-contracts';
import { LoginUser } from '../../_models';
import { Supplier } from '../../_models/supplier';

@Component({
  standalone: false,
  selector: 'app-assign-contract',
  templateUrl: './assign-contract.component.html',
  styleUrls: ['./assign-contract.component.css']
})
export class AssignContractComponent implements OnInit {
  config: any;
  SupplierID = '';
  ContractID  = '';
  ContractDescription  = '';
  prevContractDescription ='';
  SaveUpdate='';
  viewMasterList!: MstContracts[];
  arrayList!: Array<string>;
  suppliersResult!: Supplier[];
  addContract = new MstContracts();
  Id = 0;
  IsEdit=false;
  user!: LoginUser;
  constructor(
    private adminService : AdminService,
    private confirmationDialogService: ConfirmationDialogService,
    private gd : GlobalDataService,
    private modalService: NgbModal,
  ) {
    
   }

  ngOnInit() {
    this.getSuppliers();
    this.initForm();    
    this.user = this.gd.getUserData();

    
    
  }

  getSuppliers()
  {   
    this.suppliersResult= this.gd.getSupplierData();
    this.arrayList = this.suppliersResult.map(sup => sup.SupplierAB.toString().trim() +"-" +sup.SupplierName.toString().trim()); 
   
  }

  getAllSupplierContracts(SupplierID:string){
    this.adminService.getSupplierContractorList(SupplierID).subscribe(data=>{
 
      this.viewMasterList = data;      
      this.config = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.viewMasterList.length
      };
    });
  }

  selectedItem(item: { item: string; }){
    if(this.arrayList.indexOf(item.item.trim()) <= -1){
      this.openAlertModal("Invalid SupplierID");
      return;
    }
    this.getAllSupplierContracts(item.item.split('-')[0]);
   }

   searchUserCAI = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 2 ? []
        : this.arrayList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  

  initForm()
  {
    this.SupplierID = '';  
    this.ContractID = '';  
    this.ContractDescription='';
    this.IsEdit=false;
    this.SaveUpdate="Add Contract";
  }

  editContract(editContract : MstContracts) {
    this.IsEdit=true;
    this.SupplierID = editContract.SupplierID+'-'+editContract.SupplierName;
    this.ContractID = editContract.ContractId;
    this.prevContractDescription = editContract.ContractDescription; 
    this.ContractDescription = editContract.ContractDescription;    
    this.Id = editContract.ID;
    this.SaveUpdate="Update Contract";
    
  }


  
  OnSubmit(){    
    this.addContract.SupplierID = this.SupplierID.split('-')[0].trim();
    this.addContract.SupplierName = this.SupplierID.split('-')[1]== undefined ? '':this.SupplierID.split('-')[1].trim();
    this.addContract.ContractId = this.ContractID.trim() == null || this.ContractID.trim() == undefined ? '' : this.ContractID.trim() ;
    this.addContract.ContractDescription = this.ContractDescription.trim() == 'null' || this.ContractDescription.trim() == 'undefined' ? '' : this.ContractDescription.trim();
    this.addContract.IsActive = true;
    if(this.IsEdit){
      this.addContract.ID = this.Id;
      this.addContract.UpdatedBy = this.user.ProvisioningID;
      this.addContract.UpdatedDate = new Date;
      if(this.prevContractDescription != this.ContractDescription && this.viewMasterList.filter(x => x.ContractId == this.ContractID.trim()).length < 0){
        this.UpdateContract();        
        return;
      }      
    }else{
      this.addContract.CreatedBy = this.user.ProvisioningID;
      this.addContract.CreatedDate = new Date;
    }
    if(this.addContract.ContractId == ''|| this.addContract.ContractDescription == ''){
      this.openAlertModal("Enter Valid Contract Details.");
      return;
    }
    if(this.arrayList.indexOf(this.SupplierID.trim()) <= -1){
      this.openAlertModal("Invalid SupplierID");
      return;
    }
    
    if(this.viewMasterList.filter(x => x.ContractId == this.ContractID.trim()).length > 0){            
      this.openAlertModal("ContractID already exists");
      return;         
    }else{      
      this.AddContract();
      this.getAllSupplierContracts(this.SupplierID.split('-')[0].trim());
      
    }
   
  }

  public deleteConfirm(deleteContract : MstContracts) {
    this.confirmationDialogService.confirm('Please confirm..', 'Do you really want to Delete. ?')
    .then((confirmed) => {if(confirmed==true){this.deleteContract(deleteContract)}})
    .catch(() => {});
  }
  deleteContract(deleteContract : MstContracts) {
    deleteContract.IsActive=false;
    this.adminService.deleteContract(deleteContract).subscribe(res => {
      if(res == 1){
        this.openAlertModal("Data deleted successfully!");
      }else{
        this.openAlertModal("Error Occured, please try again.");
      }
      this.getAllSupplierContracts(this.SupplierID.split('-')[0].trim());
    });
  }
  

  AddContract(){
    this.adminService.addContractData(this.addContract).subscribe(data =>{
      if(data ==1){
        this.openAlertModal("Record Saved Successfully!");
      }else{
        this.openAlertModal("Error Occured, please try again.");
      }
      this.Reset();
    });
  }

  UpdateContract(){
    this.adminService.addContractData(this.addContract).subscribe(data =>{
      if(data ==1){
        this.openAlertModal("Record Saved Successfully!");        
      }else{
        this.openAlertModal("Error Occured, please try again.");
      }
      this.Reset();
      this.getAllSupplierContracts(this.SupplierID.split('-')[0].trim());
    });
  }

  Reset(){
      this.IsEdit = false;      
      this.ContractID = "";
      this.prevContractDescription = ""; 
      this.ContractDescription = "";    
      this.Id = 0;
  }

  openAlertModal(strmsg: string) {
    const modalRef = this.modalService.open(ModalPopupAlertComponent);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });  

}
}
